 
<div _ngcontent-ng-c1405646119="" class="position-relative mobile-men">
<ul _ngcontent-ng-c1405646119="" class="menu-list" id="menuListId">
<li _ngcontent-ng-c1405646119="" class="menu-item active" id="sportsBar0">
<div _ngcontent-ng-c1405646119="">
<span _ngcontent-ng-c1405646119="" class="menutext orange-nav-ic-txt">
                                        Popular
                                      </span>
</div>
</li>
<!-- -->
<li _ngcontent-ng-c1405646119="" class="menu-item" id="sportsBar1">
<div _ngcontent-ng-c1405646119="">
<span _ngcontent-ng-c1405646119="" class="menutext orange-nav-ic-txt">
                                        Universe Live
                                      </span>
</div>
</li>
<!-- -->
<li _ngcontent-ng-c1405646119="" class="menu-item" id="sportsBar2">
<div _ngcontent-ng-c1405646119="">
<span _ngcontent-ng-c1405646119="" class="menutext orange-nav-ic-txt">
                                        Universe Original
                                      </span>
</div>
</li>
<!-- -->
<li _ngcontent-ng-c1405646119="" class="menu-item" id="sportsBar3">
<div _ngcontent-ng-c1405646119="">
<span _ngcontent-ng-c1405646119="" class="menutext orange-nav-ic-txt">
                                        International
                                      </span>
</div>
</li>
<!-- -->
<li _ngcontent-ng-c1405646119="" class="menu-item" id="sportsBar4">
<div _ngcontent-ng-c1405646119="">
<span _ngcontent-ng-c1405646119="" class="menutext orange-nav-ic-txt">
                                        Slot
                                      </span>
</div>
</li>
<!-- --><!-- -->
</ul>
</div>
 
<div _ngcontent-ng-c1405646119="" class="main-con">
<div _ngcontent-ng-c1405646119="" class="row home">
<!-- -->
<div _ngcontent-ng-c1405646119="" class="col col-4 col-md-3 col-sm-3 col-xl-3 pointer prl-5px" data-bs-target="#ageconfirmationModalNew" data-bs-toggle="modal">
<div _ngcontent-ng-c1405646119="" class="casinoicons">
<a _ngcontent-ng-c1405646119=""><img _ngcontent-ng-c1405646119="" class="img-fluid" src="https://royall444.com/api/users/images/Vimaan1.webp"/></a>
</div>
</div>
<!-- --><!-- --><!-- --><!-- -->
<div _ngcontent-ng-c1405646119="" class="col col-4 col-md-3 col-sm-3 col-xl-3 pointer prl-5px" data-bs-target="#ageconfirmationModalNew" data-bs-toggle="modal">
<div _ngcontent-ng-c1405646119="" class="casinoicons">
<a _ngcontent-ng-c1405646119=""><img _ngcontent-ng-c1405646119="" class="img-fluid" src="https://royall444.com/api/users/images/20-20 teenpatti.webp"/></a>
</div>
</div>
<!-- --><!-- --><!-- --><!-- -->
<div _ngcontent-ng-c1405646119="" class="col col-4 col-md-3 col-sm-3 col-xl-3 pointer prl-5px" data-bs-target="#ageconfirmationModalNew" data-bs-toggle="modal">
<div _ngcontent-ng-c1405646119="" class="casinoicons">
<a _ngcontent-ng-c1405646119=""><img _ngcontent-ng-c1405646119="" class="img-fluid" src="https://royall444.com/api/users/images/Lucky-7.webp"/></a>
</div>
</div>
<!-- --><!-- --><!-- --><!-- -->
<div _ngcontent-ng-c1405646119="" class="col col-4 col-md-3 col-sm-3 col-xl-3 pointer prl-5px" data-bs-target="#ageconfirmationModalNew" data-bs-toggle="modal">
<div _ngcontent-ng-c1405646119="" class="casinoicons">
<a _ngcontent-ng-c1405646119=""><img _ngcontent-ng-c1405646119="" class="img-fluid" src="https://royall444.com/api/users/images/1 Day teenpatti.webp"/></a>
</div>
</div>
<!-- --><!-- --><!-- --><!-- -->
<div _ngcontent-ng-c1405646119="" class="col col-4 col-md-3 col-sm-3 col-xl-3 pointer prl-5px" data-bs-target="#ageconfirmationModalNew" data-bs-toggle="modal">
<div _ngcontent-ng-c1405646119="" class="casinoicons">
<a _ngcontent-ng-c1405646119=""><img _ngcontent-ng-c1405646119="" class="img-fluid" src="https://royall444.com/api/users/images/Joker teenpatti.webp"/></a>
</div>
</div>
<!-- --><!-- --><!-- --><!-- -->
<div _ngcontent-ng-c1405646119="" class="col col-4 col-md-3 col-sm-3 col-xl-3 pointer prl-5px" data-bs-target="#ageconfirmationModalNew" data-bs-toggle="modal">
<div _ngcontent-ng-c1405646119="" class="casinoicons">
<a _ngcontent-ng-c1405646119=""><img _ngcontent-ng-c1405646119="" class="img-fluid" src="https://royall444.com/api/users/images/Dragontiger.webp"/></a>
</div>
</div>
<!-- --><!-- --><!-- --><!-- -->
<div _ngcontent-ng-c1405646119="" class="col col-4 col-md-3 col-sm-3 col-xl-3 pointer prl-5px" data-bs-target="#ageconfirmationModalNew" data-bs-toggle="modal">
<div _ngcontent-ng-c1405646119="" class="casinoicons">
<a _ngcontent-ng-c1405646119=""><img _ngcontent-ng-c1405646119="" class="img-fluid" src="https://royall444.com/api/users/images/Baccarat.webp"/></a>
</div>
</div>
<!-- --><!-- --><!-- --><!-- -->
<div _ngcontent-ng-c1405646119="" class="col col-4 col-md-3 col-sm-3 col-xl-3 pointer prl-5px" data-bs-target="#ageconfirmationModalNew" data-bs-toggle="modal">
<div _ngcontent-ng-c1405646119="" class="casinoicons">
<a _ngcontent-ng-c1405646119=""><img _ngcontent-ng-c1405646119="" class="img-fluid" src="https://royall444.com/api/users/images/Andar Bahar.webp"/></a>
</div>
</div>
<!-- --><!-- --><!-- --><!-- -->
<div _ngcontent-ng-c1405646119="" class="col col-4 col-md-3 col-sm-3 col-xl-3 pointer prl-5px" data-bs-target="#ageconfirmationModalNew" data-bs-toggle="modal">
<div _ngcontent-ng-c1405646119="" class="casinoicons">
<a _ngcontent-ng-c1405646119=""><img _ngcontent-ng-c1405646119="" class="img-fluid" src="https://royall444.com/api/users/images/32 cards.webp"/></a>
</div>
</div>
<!-- --><!-- --><!-- --><!-- -->
<div _ngcontent-ng-c1405646119="" class="col col-4 col-md-3 col-sm-3 col-xl-3 pointer prl-5px" data-bs-target="#ageconfirmationModalNew" data-bs-toggle="modal">
<div _ngcontent-ng-c1405646119="" class="casinoicons">
<a _ngcontent-ng-c1405646119=""><img _ngcontent-ng-c1405646119="" class="img-fluid" src="https://royall444.com/api/users/images/Poker.webp"/></a>
</div>
</div>
<!-- --><!-- --><!-- --><!-- -->
<div _ngcontent-ng-c1405646119="" class="col col-4 col-md-3 col-sm-3 col-xl-3 pointer prl-5px" data-bs-target="#ageconfirmationModalNew" data-bs-toggle="modal">
<div _ngcontent-ng-c1405646119="" class="casinoicons">
<a _ngcontent-ng-c1405646119=""><img _ngcontent-ng-c1405646119="" class="img-fluid" src="https://royall444.com/api/users/images/DTL.webp"/></a>
</div>
</div>
<!-- --><!-- --><!-- --><!-- -->
<div _ngcontent-ng-c1405646119="" class="col col-4 col-md-3 col-sm-3 col-xl-3 pointer prl-5px" data-bs-target="#ageconfirmationModalNew" data-bs-toggle="modal">
<div _ngcontent-ng-c1405646119="" class="casinoicons">
<a _ngcontent-ng-c1405646119=""><img _ngcontent-ng-c1405646119="" class="img-fluid" src="https://royall444.com/api/users/images/1 Day Dragon tiger.webp"/></a>
</div>
</div>
<!-- --><!-- --><!-- --><!-- -->
<div _ngcontent-ng-c1405646119="" class="col col-4 col-md-3 col-sm-3 col-xl-3 pointer prl-5px" data-bs-target="#ageconfirmationModalNew" data-bs-toggle="modal">
<div _ngcontent-ng-c1405646119="" class="casinoicons">
<a _ngcontent-ng-c1405646119=""><img _ngcontent-ng-c1405646119="" class="img-fluid" src="https://royall444.com/api/users/images/muflisteenpatti-01.webp"/></a>
</div>
</div>
<!-- --><!-- --><!-- --><!-- -->
<div _ngcontent-ng-c1405646119="" class="col col-4 col-md-3 col-sm-3 col-xl-3 pointer prl-5px" data-bs-target="#ageconfirmationModalNew" data-bs-toggle="modal">
<div _ngcontent-ng-c1405646119="" class="casinoicons">
<a _ngcontent-ng-c1405646119=""><img _ngcontent-ng-c1405646119="" class="img-fluid" src="https://royall444.com/api/users/images/CardRace.webp"/></a>
</div>
</div>
<!-- --><!-- --><!-- --><!-- -->
<div _ngcontent-ng-c1405646119="" class="col col-4 col-md-3 col-sm-3 col-xl-3 pointer prl-5px" data-bs-target="#ageconfirmationModalNew" data-bs-toggle="modal">
<div _ngcontent-ng-c1405646119="" class="casinoicons">
<a _ngcontent-ng-c1405646119=""><img _ngcontent-ng-c1405646119="" class="img-fluid" src="https://royall444.com/api/users/images/AmarAkbarAnthony-01.webp"/></a>
</div>
</div>
<!-- --><!-- --><!-- --><!-- -->
<div _ngcontent-ng-c1405646119="" class="col col-4 col-md-3 col-sm-3 col-xl-3 pointer prl-5px" data-bs-target="#ageconfirmationModalNew" data-bs-toggle="modal">
<div _ngcontent-ng-c1405646119="" class="casinoicons">
<a _ngcontent-ng-c1405646119=""><img _ngcontent-ng-c1405646119="" class="img-fluid" src="https://royall444.com/api/users/images/dragon tiger-01.webp"/></a>
</div>
</div>
<!-- --><!-- --><!-- --><!-- -->
<div _ngcontent-ng-c1405646119="" class="col col-4 col-md-3 col-sm-3 col-xl-3 pointer prl-5px" data-bs-target="#ageconfirmationModalNew" data-bs-toggle="modal">
<div _ngcontent-ng-c1405646119="" class="casinoicons">
<a _ngcontent-ng-c1405646119=""><img _ngcontent-ng-c1405646119="" class="img-fluid" src="https://royall444.com/api/users/images/Balloon.webp"/></a>
</div>
</div>
<!-- --><!-- --><!-- --><!-- -->
<div _ngcontent-ng-c1405646119="" class="col col-4 col-md-3 col-sm-3 col-xl-3 pointer prl-5px" data-bs-target="#ageconfirmationModalNew" data-bs-toggle="modal">
<div _ngcontent-ng-c1405646119="" class="casinoicons">
<a _ngcontent-ng-c1405646119=""><img _ngcontent-ng-c1405646119="" class="img-fluid" src="https://royall444.com/api/users/images/Head n Tails.webp"/></a>
</div>
</div>
<!-- --><!-- --><!-- --><!-- -->
<div _ngcontent-ng-c1405646119="" class="col col-4 col-md-3 col-sm-3 col-xl-3 pointer prl-5px" data-bs-target="#ageconfirmationModalNew" data-bs-toggle="modal">
<div _ngcontent-ng-c1405646119="" class="casinoicons">
<a _ngcontent-ng-c1405646119=""><img _ngcontent-ng-c1405646119="" class="img-fluid" src="https://royall444.com/api/users/images/Lucky 0 to 9.webp"/></a>
</div>
</div>
<!-- --><!-- --><!-- --><!-- -->
</div>
</div>